document.addEventListener('DOMContentLoaded', () => {
  const features = document.querySelectorAll('.feature-item');

  [...features].forEach((feature) => {
    const linkContainer = feature.querySelector('.feature-link');
    const link = feature.querySelector('a');
    var spacerNode = document.createElement('div');
    spacerNode.classList.add('flex-spacer');

    if (linkContainer) {
      linkContainer.before(spacerNode);
      link.innerHTML = `<span><img width="25" height="25" src="${stylesheet_directory_uri}/images/arrow-right.png"></span>`;

      feature.addEventListener('click', () => {
        window.location.assign(link.getAttribute('href'));
      });
    }
  });
});
